import { API } from 'aws-amplify'
import AwsExports from '@/assets/aws-exports'

interface BackendAPIOptions {
  stepFunction: {
    batchUpdateUserInfoExecution: {
      name: string;
      arn: string;
      executionArnPrefix: string;
    }
  }
}

export class RezitoreAdminAPI {
  options: any

  constructor (options?: BackendAPIOptions) {
    this.options = options === undefined ? AwsExports : options
  }

  async execBatchUpdateUserInfoExecution (name: string = '', divisionId: string) {
    name = name !== '' ? name : new Date().getTime() + ''
    const myInit = {
      body: {
        'input': '{ "body": {"divisionId": "' + divisionId + '" }}',
        'name': name,
        'stateMachineArn': this.options.stepFunction.batchUpdateUserInfoExecution.arn
      }
    }
    const result = await API.post(this.options.stepFunction.batchUpdateUserInfoExecution.name, '/execution', myInit)
    return result
  }

  async getStatusBatchUpdateUserInfomationExecution (name: string) {
    const myInit = {
      body: {
        'executionArn': this.options.stepFunction.batchUpdateUserInfoExecution.executionArnPrefix + ':' + name
      }
    }
    const result = await API.post(this.options.stepFunction.batchUpdateUserInfoExecution.name, '/status', myInit)
    return result
  }

  async getUserInfoCsv (division:string, sortDateStart?: string, sortDateEnd?: string, crcId?: string) {
    const myInit = {
      body: {
        division: division,
        sortDateStart: sortDateStart,
        sortDateEnd: sortDateEnd,
        crcId: crcId
      }
    }
    const result = await API.post('UserDataCsv', '/', myInit)
    return result.body
  }

  async getUserBasicInfo (userId: string) {
    const myInit = {
      body: {
        userId: userId
      }
    }
    const result = await API.post('UserBasicInfo', '/', myInit)
    return result.body
  }

  async getUserAccessTime (userId: string, startDate?: string) {
    const myInit: any = {
      body: {
        userId: userId
      }
    }
    if (startDate !== undefined) {
      myInit['body']['startDate'] = startDate
    }
    const result = await API.post('UserBasicInfo', '/access', myInit)
    return result.body
  }

  async setConsentWithdrawal (userId: string, status: string) {
    const myInit: any = {
      body: {
        userId: userId,
        status: status
      }
    }
    const result = await API.post('UserBasicInfo', '/consentWithdrawal', myInit)
    return result.body
  }
}
